/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicMyHomeNewbuildingV2CreateRealtyRequest,
  TPublicMyHomeNewbuildingV2CreateRealtyModel,
  IMappers,
  TPublicMyHomeNewbuildingV2CreateRealtyResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ICreateRealtyResponseV2 } from '../../../../entities/web/CreateRealtyResponseV2';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createPublicMyHomeNewbuildingV2CreateRealtyModel(
  parameters: TPublicMyHomeNewbuildingV2CreateRealtyRequest,
): TPublicMyHomeNewbuildingV2CreateRealtyModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/my-home/newbuilding/v2/create-realty/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicMyHomeNewbuildingV2CreateRealtyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicMyHomeNewbuildingV2CreateRealtyRequest;
}

export async function fetchPublicMyHomeNewbuildingV2CreateRealty<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMyHomeNewbuildingV2CreateRealtyOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicMyHomeNewbuildingV2CreateRealtyResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicMyHomeNewbuildingV2CreateRealtyModel(parameters),
    config,
  )) as FetchResponse<TPublicMyHomeNewbuildingV2CreateRealtyResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateRealtyResponseV2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicMyHomeNewbuildingV2CreateRealtyResponse>;
}
